import React from 'react'
import { AutoridadeRegistros } from './autoridade-registros/autoridade-registros-tabela'
import { Titulo, RepositorioCollapsible, RepositorioOpcao } from '@components'
import './repositorio.css'
import ENV from '@environments'

const LinkContainer = ({ titulo, children }) => (
  <div>
    {titulo && <p className="ac-digital-titulo">{titulo}</p>}
    {children}
  </div>
)

const Arquivo = ({ arquivo }) => (
  <RepositorioOpcao url={arquivo?.caminho} type="document">
    {arquivo?.titulo}
  </RepositorioOpcao>
)

const Grupo = ({ grupo }) => (
  <LinkContainer titulo={grupo.titulo}>
    {grupo.arquivos.map((arquivo) => (
      <Arquivo key={arquivo.titulo} arquivo={arquivo} />
    ))}
  </LinkContainer>
)

const AcContainer = ({ ac, type }) => (
  <RepositorioCollapsible title={ac?.titulo}>
    <div className="ac-digital-container">
      {ac?.grupos.map((grupo) => (
        <Grupo key={grupo?.titulo} grupo={grupo} />
      ))}

      {type === 'ac2' && (
        <LinkContainer titulo="Autoridades de Registro">
          <AutoridadeRegistros />
        </LinkContainer>
      )}
    </div>
  </RepositorioCollapsible>
)

const PrestadoresDeServicoESuporte = ({ instituicao }) => {
  console.log(instituicao)
  return (
    <>
      <li>
        {instituicao.url ? (
          <p>
            <a href={instituicao.url} target="_blank" rel="noopener noreferrer" className="repositorio-pss-link">
              {instituicao.nome}
            </a>
          </p>
        ) : (
          <p>{instituicao.nome}</p>
        )}
      </li>
    </>
  )
}

const PssContainer = ({ pss }) => (
  <RepositorioCollapsible title={pss?.titulo}>
    <div className="prestador-servico-suporte">
      <ul className="prestador-servico-suporte-opcoes">
        {pss?.instituicoes.map((instituicao) => (
          <PrestadoresDeServicoESuporte key={instituicao} instituicao={instituicao} />
        ))}
      </ul>
    </div>
  </RepositorioCollapsible>
)

const PscContainer = ({ psc }) => (
  <RepositorioCollapsible title={psc?.titulo}>
    <div>
      <ul>
        {psc?.informacoes.map((informacao) => (
          <li key={informacao}>
            {informacao.arquivo ? (
              <>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: 'column',
                    alignItems: 'start',
                    padding: '10px',
                  }}
                >
                  <strong>{informacao.titulo}</strong>
                  <Arquivo arquivo={informacao.arquivo} />
                </div>
              </>
            ) : (
              <span
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  flexDirection: 'column',
                  alignItems: 'start',
                  padding: '10px',
                }}
              >
                <strong>{informacao.titulo}?</strong>
                {informacao.descricao}
              </span>
            )}
          </li>
        ))}
      </ul>

      <div>
        <LinkContainer titulo="Documentos normativos do Prestador de Serviço de Confiança - PSC ACDIGITAL">
          {psc?.arquivos.map((arquivo) => (
            <>
              <Arquivo arquivo={arquivo} />
            </>
          ))}
        </LinkContainer>
      </div>
    </div>
  </RepositorioCollapsible>
)

const Repositorio = ({ repositorio }) => (
  <>
    <AcContainer ac={repositorio?.ac1} />

    {repositorio?.ac2.map((ac2) => (
      <AcContainer key={ac2?.titulo} ac={ac2} type="ac2" />
    ))}

    <PssContainer pss={repositorio?.pss} />

    <PscContainer psc={repositorio?.psc} />
  </>
)

export const RepositorioScreen = () => {
  return (
    <div className="repositorio-container">
      <Titulo>Repositório</Titulo>
      <div className="repositorio-content-container">
        <Repositorio repositorio={ENV.REPOSITORIO} />
      </div>
    </div>
  )
}
